import { Uuid } from "@/domains/global/identifiers";
import { UuidNamespace } from "@/modules/uuid/constants";
import { v5 as uuidv5 } from "uuid";

/**
 * Generate a deterministic UUID for CalendarConnection based on space_account_id,
 * subject_id, and provider_kind.
 *
 * This matches the backend's resolve_calendar_connection_uuid function.
 *
 * @param spaceAccountId - The space account ID
 * @param subjectId - The provider's subject ID (e.g., Google subject ID)
 * @param providerKind - The provider kind (e.g., "GOOGLE_CALENDAR", "OUTLOOK_CALENDAR")
 * @returns Deterministic UUID for the CalendarConnection
 */
export const resolveCalendarConnectionUuid = ({
  spaceAccountId,
  subjectId,
  providerKind,
}: {
  spaceAccountId: string;
  subjectId: string;
  providerKind: string;
}): Uuid => {
  const upperSpaceAccountId = spaceAccountId.toUpperCase();
  const upperSubjectId = subjectId.toUpperCase();
  const upperProviderKind = providerKind.toUpperCase();
  const name = `${upperSpaceAccountId}::${upperSubjectId}::${upperProviderKind}`;
  return uuidv5(name, UuidNamespace.SyncModelNamespace);
};
